import { useLocation } from "react-router";
import consts, { navIndex } from "./consts";

/**
 * Evaluates current location pathname (from useLocation) & query string and returns expected navIndex & filter
 * represented by left main navigation
 * @returns Current navIndex (Or what is supposed to be current navIndex)
 */
export default function useNavIndexFromLocation(): { index?: navIndex; subMenuName?: string } | undefined {
	const location = useLocation();
	const pathname = location.pathname;

	for (const menuItem of consts.leftNav) {
        if (pathname === menuItem.path) {
        // This is a top-level menu item
            return { index: menuItem.index, subMenuName: undefined };
        }
		
        const subMenuItem = menuItem.subMenuItems?.find((s) => s.path === pathname);
        if (subMenuItem) {
            return { index: subMenuItem.index, subMenuName: menuItem.name };
        }
    }
	return undefined;
}
